import {
  ActivitiesIcon,
  ComplaintIcon,
  FacilityIcon,
  HouseCareServiceIcon,
  NewsAnnouncementIcon,
  ParcelIcon,
  ResidentsIcon,
  RoutineIcon,
  SaleAndRentIcon,
  SurveyIcon,
  VehicleIcon,
  WorkSpaceIcon,
} from "assets/images/icon/menu";
import { IBaseService, IPagination } from "config/axios/interface";
import { MenuSlug, MenuTypes } from "menus/interface";
import { IProperty } from "service/property/interface";

export interface INotification {
  success: boolean;
  data: INotificationDetails[];
}

export interface INotificationDetails extends IBaseService {
  isRead: boolean;
  deletedAt: string;
  userUuid: string;
  property: IProperty;
  propertyUuid: string;
  propertyUnitUuid: string;
  itemId: number;
  notiCategory: MenuSlug;
  notiDetail: NotiDetail;
}

export interface INotificationParams extends IPagination {
  notiCategory?: MenuSlug;
  uuid?: string;
}

export interface NotiDetail {
  en: string;
  th: string;
}

export interface PropertyUnit {
  id: number;
  createdAt: string;
  updatedAt: string;
  uuid: string;
  unitNumber: string;
  buildingName: string;
  floor: number;
  houseNumber: string;
  unitTypes?: string;
  propertyCode: string;
  referenceNumber: string;
  isActive: boolean;
  transferDate: any;
  address: string;
  expiredDate: any;
  linkUrl: any;
  property: Property;
}

export interface Property {
  id: number;
  createdAt: string;
  updatedAt: string;
  uuid: string;
  nameTh: string;
  nameEn: string;
  title?: string;
  juristicPersonNameTh: string;
  juristicPersonNameEn: string;
  phoneNumber?: string;
  province?: string;
  propertyCode?: string;
  juristicEmail?: string;
  isActive: boolean;
  countMenuPermission: any;
}

export interface IMenuNoti {
  notiCategory: MenuSlug;
  key: MenuTypes;
  title: MenuTypes;
  icon?: React.ComponentType;
  to: string;
  code: string;
  slug?: string;
}

export const MENUS_NOTI: IMenuNoti[] = [
  {
    key: "news-and-announcement",
    title: "news-and-announcement",
    to: "/news-and-announcement",
    icon: NewsAnnouncementIcon,
    code: "0300",
    notiCategory: "NEWS_AND_ANNOUNCEMENT",
  },
  {
    key: "activities",
    title: "activities",
    to: "/activities",
    icon: ActivitiesIcon,
    code: "0400",
    notiCategory: "ACTIVITIES_MANAGE",
  },
  {
    key: "survey",
    title: "survey",
    to: "/survey",
    icon: SurveyIcon,
    code: "0500",
    notiCategory: "SATISFACTION_SURVEY",
  },
  {
    key: "residents",
    title: "residents",
    to: "/residents",
    icon: ResidentsIcon,
    code: "0700",
    notiCategory: "RESIDENTS",
  },
  {
    key: "work-manage",
    title: "work-manage",
    to: "/work-manage/unroutine",
    icon: RoutineIcon,
    code: "1200",
    notiCategory: "WORK_MANAGE",
  },
  {
    key: "work-space",
    title: "work-space",
    to: "/work-space/request",
    icon: WorkSpaceIcon,
    code: "1400",
    notiCategory: "APPLIANCES_REQUEST",
  },
  {
    key: "sell-and-rent",
    title: "sell-and-rent",
    to: "/sell-and-rent",
    icon: SaleAndRentIcon,
    code: "1100",
    notiCategory: "MDPC",
  },
  {
    key: "complaint",
    title: "complaint",
    to: "/complaint/list",
    icon: ComplaintIcon,
    code: "1300",
    notiCategory: "COMPLAINT",
  },
  {
    key: "property.news-and-announcement",
    title: "property.news-and-announcement",
    to: "/property/news-and-announcement",
    icon: NewsAnnouncementIcon,
    code: "2100",
    notiCategory: "PROPERTY_NEWS_AND_ANNOUNCEMENT",
  },
  {
    key: "property.activities",
    title: "property.activities",
    to: "/activities",
    icon: ActivitiesIcon,
    code: "3900",
    notiCategory: "PROPERTY_ACTIVITIES",
  },
  {
    key: "property.house-care-service.list",
    title: "property.house-care-service.list",
    to: "/house-care-service/list",
    icon: HouseCareServiceIcon,
    code: "2301",
    notiCategory: "REPAIRING",
  },
  {
    key: "property.parcel.list",
    title: "property.parcel.list",
    to: "/parcel/list",
    icon: ParcelIcon,
    code: "2401",
    notiCategory: "PROPERTY_PARCEL",
  },
  {
    key: "property.facility.list",
    title: "property.facility.list",
    to: "/facility/booking",
    icon: FacilityIcon,
    code: "2502",
    notiCategory: "PROPERTY_FACILITY",
  },
  {
    key: "property.vehicle",
    title: "property.vehicle",
    to: "/vehicle",
    icon: VehicleIcon,
    code: "2800",
    notiCategory: "VEHICLE",
  },
  {
    key: "property.complaint.list",
    title: "property.complaint.list",
    to: "/complaint/list",
    icon: ComplaintIcon,
    code: "2901",
    notiCategory: "PROPERTY_COMPLAINT",
  },
  {
    key: "property.sell-and-rent",
    title: "property.sell-and-rent",
    to: "/sell-and-rent",
    icon: SaleAndRentIcon,
    code: "3100",
    notiCategory: "PROPERTY_MDPC",
  },
  {
    key: "property.routine",
    title: "property.routine",
    to: "/work-manage/routine",
    icon: RoutineIcon,
    code: "5001",
    notiCategory: "PROPERTY_WORK_MANAGE",
  },
  {
    key: "property.unroutine",
    title: "property.unroutine",
    to: "/work-manage/unroutine",
    icon: RoutineIcon,
    code: "5002",
    notiCategory: "PROPERTY_WORK_MANAGE",
  },
  {
    key: "property.survey",
    title: "property.survey",
    to: "/property/survey",
    icon: SurveyIcon,
    code: "4100",
    notiCategory: "PROPERTY_SATISFACTION_SURVEY",
  },
  {
    key: "appliances",
    title: "appliances",
    to: "/appliances",
    icon: WorkSpaceIcon,
    code: "1900",
    notiCategory: "APPLIANCES",
  }, 
  {
    key: "appliances-asset",
    title: "appliances-asset",
    to: "/appliances-asset",
    icon: WorkSpaceIcon,
    code: "1900",
    notiCategory: "APPLIANCES_ASSET",
  },
  {
    key: "appliances-superfluous",
    title: "appliances-superfluous",
    to: "/appliances-superfluous",
    icon: WorkSpaceIcon,
    code: "1900",
    notiCategory: "APPLIANCES_SUPERFLUOUS",
  },
];
